import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { bubEvents } from 'shared/events/bub_events';

import { ChirpButton } from 'javascripts/components/chirp_button';
import { CoverImage } from 'javascripts/components/cover_image';
import { Modal } from 'javascripts/components/modal';
import { StarRating } from 'javascripts/components/star_rating';

import styles from 'stylesheets/components/reviews/shared_review_modal';

export function SharedReviewModal({
  audiobookId,
  authorCredits,
  coverUrl,
  displayAuthors,
  displayTitle,
  free,
  purchaseUrl,
  userNamePossessive,
  userRating,
  userReviewId,
  userReviewText,
}) {
  const [isOpen, setIsOpen] = useState(true);
  const buyButtonLabel = free ? 'Get this audiobook for free!' : 'Buy Now';

  const trackBuyButtonClicks = () => {
    bubEvents.track('Audiobook details', 'Clicked buy button on shared review modal', {
      label: 'Audiobook id',
      value: audiobookId,
    });

    if (window.gtag !== undefined) {
      gtag('event', 'buy_now', {
        event_category: 'purchase',
        event_label: displayTitle,
      });
    }
  };

  function trackAndCloseModal() {
    bubEvents.track('Audiobook page', 'Closed shared review modal', {
      label: 'Review id',
      value: userReviewId,
    });
    setIsOpen(false);
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={trackAndCloseModal}>
      <div className={styles.sharedReviewModal} data-testid='shared-review-modal'>
        <h1 className={styles.header}>{`${userNamePossessive} Review`}</h1>
        <div className={styles.audiobook}>
          <div className={styles.cover}>
            <CoverImage
              coverUrl={coverUrl}
              bookTitle={displayTitle}
              bookAuthor={displayAuthors}
              bookId={audiobookId}
              defer={false}
            />
          </div>
          <div className={styles.audiobookDetails}>
            <h3 className={styles.title}>{displayTitle}</h3>
            <h4 className={styles.byline}>
              by{' '}
              {_.join(
                authorCredits.map(author => author.name),
                ', ',
              )}
            </h4>
            <div className={styles.rating}>
              <StarRating rating={userRating} size='large' />
            </div>
          </div>
        </div>
        <div className={styles.reviewText}>{userReviewText}</div>
        <ChirpButton
          displayStyle='yellow'
          fullWidth
          href={purchaseUrl}
          label={buyButtonLabel}
          onClick={trackBuyButtonClicks}
        />
        <ChirpButton class={styles.learnMore} label='Learn More' fullWidth onClick={trackAndCloseModal} />
      </div>
    </Modal>
  );
}

SharedReviewModal.propTypes = {
  audiobookId: PropTypes.string.isRequired,
  authorCredits: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  coverUrl: PropTypes.string.isRequired,
  displayAuthors: PropTypes.string.isRequired,
  displayTitle: PropTypes.string.isRequired,
  free: PropTypes.bool,
  purchaseUrl: PropTypes.string.isRequired,
  userNamePossessive: PropTypes.string.isRequired,
  userRating: PropTypes.number.isRequired,
  userReviewId: PropTypes.string.isRequired,
  userReviewText: PropTypes.string.isRequired,
};
